<div class="loading-spinner">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
